module.exports = __webpack_public_path__ + "img/beer_id-76.f4c7192f.png";